import { Pipe, PipeTransform } from '@angular/core';
import { PricesService } from 'app/core/services/prices.service';
import { CartItem, CartItemSelectorService } from 'app/features/cart';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'cartCurrentListPrice',
})
export class CartCurrentListPricePipe implements PipeTransform {
  constructor(private cartItemSelectorService: CartItemSelectorService, private pricesService: PricesService) {}

  transform(cartItems: CartItem[]): Observable<string> {
    return this.cartItemSelectorService.getTotalCartPrice().pipe(
      map((asyncCartItemPrices) => {
        let cartItemPrices = asyncCartItemPrices.map((cartItemPrice) => cartItemPrice.data);

        if (cartItems) {
          cartItemPrices = cartItemPrices.filter((cartItemPrice) => {
            if (cartItems.find((cartItem) => cartItem.Id === cartItemPrice.Id)) {
              return cartItemPrice;
            }
          });
          return this.pricesService.summarizePrices(cartItemPrices);
        }

        return this.pricesService.summarizePrices(cartItemPrices);
      })
    );
  }
}
